export default __webpack_public_path__ + "static/media/Roboto-Bold.b437a5ee.ttf";